import makeFetch from "../../utils/http";

export function api_setInvoicePreview(body) {
    return makeFetch(
        "invoices/previews",
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_postAppointmentRequest(body) {
    return makeFetch(
        "appointmentRequests",
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_getAppointmentUploadURL(id, isVideoUpload=false) {
    return makeFetch(
        `appointments/upload/${id}`,
        "GET",
        {isVideoUpload}
    );
}

export function api_getLastAppointment() {
    return makeFetch(
        "appointments/last",
        "GET"
    );
}

export function api_getTimeSlots(vetUserId, time) {
    return makeFetch(
        "profiles/timeslots",
        "GET",
        {vetUserId, time}
    );
}
